module.exports = __webpack_public_path__ + "img/meauicon1.ce3f2796.svg";